import { TextButton } from '@wix/design-system';
import React from 'react';
const Noop = () => {
  return null;
};
export const getTranslationTags = props => {
  const {
    url,
    isMobile
  } = props || {};
  const Link = url ? isMobile ? /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    href: url,
    size: "tiny",
    target: "_blank",
    skin: "dark",
    underline: "always",
    weight: "normal"
  }) : /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    href: url,
    size: "tiny",
    target: "_blank"
  }) : /*#__PURE__*/React.createElement(Noop, null);
  return {
    Link,
    voucher: /*#__PURE__*/React.createElement(Noop, null),
    b: /*#__PURE__*/React.createElement("b", null)
  };
};
//# sourceMappingURL=getTranslationTags.js.map